import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function fetchReasonCodeDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'reason_code/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function saveReasonCode(app, dataToSave) {
  const { user={}, data } = dataToSave;
  let reasonCode = {
    doc_type: DocType.REASON_CODE,
    name: util.toStringText(data.name),
    short_name: util.toStringText(data.short_name),
    active: util.toBoolean(data.active),
    sale: util.toBoolean(data.sale),
    purchase: util.toBoolean(data.purchase),
    receipt: util.toBoolean(data.receipt),
    returned: util.toBoolean(data.returned),
    credit: util.toBoolean(data.credit),
    voided: util.toBoolean(data.voided),
    inventory: util.toBoolean(data.inventory),
    till_device: util.toBoolean(data.till_device),
    task: util.toBoolean(data.task),
    system_defined: util.toBoolean(data.system_defined),
  };

  return common.saveDoc(app, {
    source: data,
    doc: reasonCode,
    user,
  });
}

export function deleteReasonCode(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.REASON_CODE
  });
}

export function fetchReasonCodeById(app, params) {
  const { id } = params;
  const docType = DocType.REASON_CODE;
  return common.getDoc(app, { id, docType });
}
